import { AgGridReact } from "ag-grid-react";
import { TCiqLogHeader } from "components/ciq-grid-view-wrapper/model";
import { useMemo } from "react";
import { FeatureTypes } from "entity-app/constants";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { entityLogFilterTitles } from "../../constants";
import { getGridStatusBudge } from "./grid-status-budge";

export const calculateLogPageStats = (props: {
  gridRef: React.RefObject<AgGridReact<any>>;
  ListFilter?: any;
  featureTypeId?: FeatureTypes;
}) => {
  const { gridRef, ListFilter, featureTypeId } = props;
  if (!gridRef.current?.api) return undefined;
  const isAnyFilterPresent = gridRef.current?.api?.isAnyFilterPresent();
  if (!isAnyFilterPresent) return undefined;

  const displayedRowCount = gridRef.current?.api?.getDisplayedRowCount();
  if (displayedRowCount === undefined) return undefined;

  const data = {
    displayCount: displayedRowCount,
    filterName: undefined
  };

  if (featureTypeId && ListFilter && ListFilter.key) {
    const titles = entityLogFilterTitles(featureTypeId);
    const titleText = titles[ListFilter.key];
    data.filterName = titleText;
  }

  return data;
};

function CiqLogPageHeader({
  entityName,
  items,
  titleParam,
  className = "px-6 py-4 flex justify-between items-center",
  backButton,
  onAllRecordsClick,
  backButtonTestId
}: TCiqLogHeader & { backButtonTestId?: string }) {
  const statusBudge = useMemo(
    () => getGridStatusBudge(titleParam, onAllRecordsClick),
    [titleParam, onAllRecordsClick]
  );

  return (
    <div className={className}>
      <div className="flex space-x-2 items-center text-black">
        {backButton && (
          <ArrowLeftOutlined
            className="text-black"
            onClick={backButton}
            data-testid={backButtonTestId}
          />
        )}
        <div
          className="text-xl font-semibold"
          data-testid="feature-entity-name"
        >
          {entityName}
        </div>
        <span data-testid="feature-entity-status-badge">{statusBudge}</span>
      </div>

      <div className="flex space-x-2 items-center">{items}</div>
    </div>
  );
}
export default CiqLogPageHeader;
